export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-heading text-2xl text-primary-500 whitespace-nowrap">69视频</span>
            <p className="text-sm text-foreground-400 mt-3 leading-relaxed">
              69视频汇聚西瓜视频免费、91在线视频等优质影视资源，提供高清电影、电视剧、综艺节目免费在线观看服务，每日更新热播内容，打造流畅不缓冲的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '特色优势', href: '#features' },
                { label: '热播榜单', href: '#ranking' },
                { label: '话题广场', href: '#topics' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleClick(e, item.href)}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4 whitespace-nowrap">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              {['电影大片', '热门剧集', '综艺娱乐', '动漫番剧', '纪录片'].map((label) => (
                <a
                  key={label}
                  href="#index"
                  onClick={(e) => handleClick(e, '#index')}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-200 mb-4 whitespace-nowrap">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-200/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 69视频 · 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#faq" onClick={(e) => handleClick(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}